var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./product/detail"));
    processInclude(require("./components/contentPlusCarousel"));
    processInclude(require("./product/imageZoom"));

    // load file only if #authenticatedModal exists
    if ($("#authenticatedModal").length) {
        processInclude(require("./components/notAuthenticatedModal"));
    }
});

require("./thirdParty/image-zoom.min");
